import { render } from "./DomainList.vue?vue&type=template&id=5c612a40&scoped=true"
import script from "./DomainList.vue?vue&type=script&lang=js"
export * from "./DomainList.vue?vue&type=script&lang=js"

import "./DomainList.vue?vue&type=style&index=0&id=5c612a40&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c612a40"]])

export default __exports__